module.exports = __webpack_public_path__ + "img/two1.6e3e8dda.png";